"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonUtils_1 = require("../../../Helpers/commonUtils");
const createUrl = (baseUrl, vi, params) => {
    let url = baseUrl + vi.id;
    url += (0, commonUtils_1.combineParams)({
        params,
    });
    return url;
};
const parseUrl = (url) => {
    const match = url.match(/(?:(?:embed|sid)\/|v_show\/id_|VideoIDS=)([a-zA-Z0-9]+)/);
    return match ? match[1] : undefined;
};
const parseParameters = (params) => {
    const parsedParams = Object.assign({}, params);
    if (parsedParams.VideoIDS) {
        delete parsedParams.VideoIDS;
    }
    return parsedParams;
};
const Youku = {
    provider: 'youku',
    defaultFormat: 'long',
    formats: {
        embed: (vi, params) => {
            return createUrl('//player.youku.com/embed/', vi, params);
        },
        long: (vi, params) => {
            return createUrl('//v.youku.com/v_show/id_', vi, params);
        },
        flash: (vi, params) => {
            let url = `//player.youku.com/player.php/sid/${vi.id}/v.swf`;
            url += (0, commonUtils_1.combineParams)({
                params,
            });
            return url;
        },
        static: (vi, params) => {
            return createUrl('//static.youku.com/v1.0.0638/v/swf/loader.swf?VideoIDS=', vi, params);
        },
    },
    mediaTypes: {
        VIDEO: 'video',
    },
    parse: (url, params) => {
        const id = parseUrl(url);
        if (!id) {
            return undefined;
        }
        return {
            mediaType: Youku.mediaTypes.VIDEO,
            id,
            params: parseParameters(params),
        };
    },
    createEmbedUrl: (vi, params) => {
        return createUrl('//player.youku.com/embed/', vi, params);
    },
    createLongUrl: (vi, params) => {
        return createUrl('//v.youku.com/v_show/id_', vi, params);
    },
    createStaticUrl: (vi, params) => {
        return createUrl('//static.youku.com/v1.0.0638/v/swf/loader.swf?VideoIDS=', vi, params);
    },
    createFlashUrl: (vi, params) => {
        let url = `//player.youku.com/player.php/sid/${vi.id}/v.swf`;
        url += (0, commonUtils_1.combineParams)({
            params,
        });
        return url;
    },
};
exports.default = Youku;
